import { ResponsiveScatterPlot } from "@nivo/scatterplot";

type SampleDatum = {
  x: number;
  y: number;
  version: number;
};

export const MyResponsiveScatterPlot = ({ data }) => (
  <>
    <div className="h-[336px] hidden lg:block">
      <ResponsiveScatterPlot<SampleDatum>
        data={data}
        margin={{ top: 60, right: 120, bottom: 70, left: 90 }}
        xScale={{
          type: "time",
          format: "%Y-%m-%d",
          precision: "day",
        }}
        colors={{ scheme: "set3" }}
        xFormat="time:%Y-%m-%d"
        axisBottom={{
          format: "%b %Y",
          tickValues: "every month",
        }}
        yScale={{ type: "linear", min: 0, max: "auto" }}
        yFormat=">-.2f"
        blendMode="multiply"
        axisTop={null}
        axisRight={null}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Release Index",
          legendPosition: "middle",
          legendOffset: -60,
          truncateTickAt: 0,
        }}
        tooltip={({ node }) => {
          return (
            <div
              style={{
                color: node.color,
                background: "#fff",
                padding: "12px 16px",
                border: "1px black solid",
                borderRadius: "8px",
              }}
            >
              <strong>{node.serieId}</strong>
              <br />
              {`date: ${node.formattedX}`}
              <br />
              {`version: ${node.data.version}`}
            </div>
          );
        }}
      />
    </div>
    <div className="h-[336px] mb-6 w-full lg:hidden">
      <ResponsiveScatterPlot<SampleDatum>
        data={data}
        margin={{ top: 20, right: 10, bottom: 70, left: 30 }}
        xScale={{
          type: "time",
          format: "%Y-%m-%d",
          precision: "day",
        }}
        colors={{ scheme: "set3" }}
        xFormat="time:%Y-%m-%d"
        axisBottom={{
          format: "%b %Y",
          tickValues: "every month",
          tickRotation: -90,
        }}
        yScale={{ type: "linear", min: 0, max: "auto" }}
        yFormat=">-.2f"
        blendMode="multiply"
        axisTop={null}
        axisRight={null}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Release Index",
          legendPosition: "middle",
          legendOffset: -60,
          truncateTickAt: 0,
        }}
        tooltip={({ node }) => {
          return (
            <div
              style={{
                color: node.color,
                background: "#fff",
                padding: "12px 16px",
                border: "1px black solid",
                borderRadius: "8px",
              }}
            >
              <strong>{node.serieId}</strong>
              <br />
              {`date: ${node.formattedX}`}
              <br />
              {`version: ${node.data.version}`}
            </div>
          );
        }}
      />
    </div>
  </>
);
